<template>
  <div id="EventAdd">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">頁面编辑</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">頁腳</li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'footPage' }"> 頁面管理 </router-link>
              </li>
              <li class="breadcrumb-item active">頁面编辑</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-md-8 col-sm-12">
            <div class="card card-secondary">
              <div class="card-body">
                <el-form :model="EventModel" ref="EventModel" :rules="rules">
                  <el-form-item
                    label="頁面標題"
                    label-width="80px"
                    prop="title"
                  >
                    <el-input v-model="EventModel.title"></el-input>
                  </el-form-item>
                  <el-form-item label="内容" prop="sgL_Content">
                    <Editor v-model="EventModel.sgL_Content" />
                  </el-form-item>
                  <el-form-item label="關鍵字（以 ',' 作分隔，不需加上空格）">
                    <el-input
                      v-model="EventModel.sgL_keyWord"
                      placeholder="e.g. 聯絡,聯絡方式,電話,contact…"
                      type="textarea"
                      :rows="1"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="公開狀態" prop="sgL_IsShow">
                    <el-select
                      v-model="EventModel.sgL_IsShow"
                      clearable
                      placeholder="公開狀態"
                    >
                      <el-option label="公開" :value="true"></el-option>
                      <el-option label="隱藏" :value="false"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="URL" prop="sgL_RequestUrl">
                    <el-input v-model="EventModel.sgL_RequestUrl"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div
                style="display: flex; justify-content: center; margin: 5px 0px"
              >
                <el-button
                  class="float-right"
                  @click="$router.push({ name: 'footPage' })"
                  >取消</el-button
                >
                <el-button
                  type="primary"
                  class="float-right"
                  @click="submitForm('EventModel')"
                  >保存</el-button
                >
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
            <!-- /.card -->
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content -->
  </div>
</template>
<script>
import Editor from "../common/Editor";
import { Message } from "element-ui";
export default {
  data() {
    return {
      EventModel: {
        id: 0,
        title: null,
        sgL_IsShow: true,
        sgL_Content: null,
        sgL_keyWord: null,
        sgL_RequestUrl: "",
      },
      rules: {
        title: [{ required: true, message: "請輸入名稱", trigger: "blur" }],
        sgL_Content: [
          { required: true, message: "請輸入内容", trigger: "blur" },
        ],
        sgL_keyWord: [
          { required: true, message: "請輸入狀態", trigger: "change" },
        ],
        sgL_RequestUrl: [
          { required: true, message: "請輸入URL", trigger: "blur" },
        ],
      },
    };
  },
  components: {
    Editor,
  },
  created() {
    this.EventModel.id = this.$route.query.id;
    if (this.EventModel.id != undefined && this.EventModel.id != "") {
      //修改，查询此id的信息
      this.getById(this.EventModel.id);
    }
  },
  methods: {
    submitForm(formname) {
      this.$refs[formname].validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.EventModel);
          const med =
            params.id > 0
              ? this.$api.permissionApi.editFootContentInfo
              : this.$api.permissionApi.createFootContent;
          med(params).then((res) => {
            if (res.data.success) {
              Message({
                type: "success",
                message: this.$t('message.operatesuccessfully'),
              });
              this.$router.push({ name: "footPage" });
            } else {
              Message({
                type: "error",
                message: this.$t('message.operationfailure'),
              });
            }
          });
        }
      });
    },
    getById(id) {
      let params = {
        id,
      };
      this.$api.permissionApi.getFootContentInfo(params).then((res) => {
        if (res.data.success) {
          this.EventModel = res.data.result;
        }
      });
    },
    getEventArea(PId) {
      let params = {
        SGL_TypeT: 30, //城市
        MaxResultCount: 100,
        SGL_ParentID: 1, //區域
        SGL_NewTypeId: PId,
      };
      this.$api.EventApi.GetEventType(params).then((res) => {
        if (res.data.success) {
          this.EventAreaList = res.data.result.items;
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/AdminFooter/pageEdit.vue